define('boxes/mobile-verification-box',['jquery', 'boxes/events/bonus-event', 'boxes/helpers/verification', 'boxes/helpers/message-popup', 'boxes/box', 'boxes/helpers/box-loading',
    'all/comeon', 'all/paymentServices-toggles', 'all/jquery/jquery.mustache'], function($, bonusEvent, verification, messagePopup, box, boxLoading, comeon,
                                                                                         paymentServicesToggles) {

    'use strict';

	var doneCallback = undefined;

	function setDoneCallback(cb) {
		doneCallback = cb;
	}

    function getDepositVerificationUrlForQuery() {

        return paymentServicesToggles.useNewPaymentFormDataService()
            ? '/PaymentFormDataService/getDepositVerification' + '?' : '/pp?flow=GetDepositVerification' + '&';
    }

    function getWithdrawVerificationUrl() {

        return paymentServicesToggles.useNewPaymentFormDataService()
            ? '/PaymentFormDataService/getWithdrawVerification' : '/pp?flow=GetWithdrawVerification';
    }

    function verifyMobile($box, $controller) {
        var $code = $box.find('input[name="code"]').val();
        $.get('/pp?flow=MobileVerification&PARAM_CODE=' + $code, function (data) {
            if (data.RESULT === 'NOT_OK') {
                boxLoading.removeLoading($box);
                messagePopup.show($box, 'message-popup', {
                    title: data.ERROR_HEADER,
                    message: data.ERROR,
                    closeButtonText: data.BUTTON_OK
                });
            } else {
				if(doneCallback !== undefined) {
					doneCallback(data, $box, $controller);
				} else {
					$controller.nextBox();
				}
            }
        });
    }

    function resendMobile($box, onlyShowError) {
        $.get('/pp?flow=ResendMobileVerification&isNewFlow=true', function (data) {
            boxLoading.removeLoading($box);
            var title,
                message;

            if (data.RESULT === 'OK') {
                title = data.CODE;
                message = data.TEXT;
            } else {
                title = data.ERROR_HEADER;
                message = data.ERROR;
            }

            if (onlyShowError && data.RESULT === 'OK') {
                return;
            }

            messagePopup.show($box, 'message-popup',{
                title: title,
                message: message,
                closeButtonText: data.BUTTON_OK
            });
        });
    }

    function showErrorTooltip($inputElement, errorMessage) {
        var $inputContainer = $inputElement.parent().parent();
        $inputContainer.addClass('has-error');
        $inputContainer.popover('destroy');
        $inputContainer.popover({
            content: errorMessage,
            container: $inputContainer,
            trigger: 'manual',
            placement: 'right'
        }).popover('show');
    }

    function updateMobile($box, $changeFrame, $verifyFrame) {
        var $inputElement = $changeFrame.find('input'),
            $newCountryCode = $inputElement.first().val(),
            $newMobileNumber = $changeFrame.find('input:eq(1)').val(),
            $oldMobile = $verifyFrame.find('.inner div.container div.col b'),
            $newMobile = $newCountryCode + $newMobileNumber;

        if ($newMobile === $oldMobile.text()) {
            $changeFrame.hide();
            $verifyFrame.show();
            verification.resetChangeFrame($inputElement);
            boxLoading.removeLoading($box);
            return;
        }
        $newCountryCode = $newCountryCode.replace('+', '');

        $.ajax({
            url: '/pp?flow=CheckMobile',
            data: {
                PARAM_PHONE_NUMBER: $newMobileNumber,
                PARAM_CALLING_CODE: $newCountryCode
            }
        }).done(function (data) {
            if (data.RESULT === 'NOT_OK') {
                showErrorTooltip($inputElement, data.ERROR);
                boxLoading.removeLoading($box);
            } else {
                $.get('/pp?flow=UpdateMobile&PARAM_MOBILE_PHONE_COUNTRY_CODE=' +
                    $newCountryCode + '&PARAM_MOBILE_PHONE=' +
                    $newMobileNumber, function (data) {
                    boxLoading.removeLoading($box);
                    if (data.RESULT === 'OK') {
                        $oldMobile.text($newMobile);
                        $changeFrame.hide();
                        $verifyFrame.show();
                        verification.resetChangeFrame($inputElement);
                    } else {
                        showErrorTooltip($inputElement, data.PARAM_MOBILE_PHONE);
                    }
                });
            }
        });
    }

    function setupDepositVerificationEventHandlers(mobileVerification) {
        mobileVerification.$controller.on(bonusEvent.BONUS_CHANGED, function (event, bonusData) {
            var parameterData = { isBonusSelected: true };
            if (bonusData.isFree === true) {
                $.extend(parameterData, { isBonusFree: true });
            } else {
				$.extend(parameterData, { isBonusFree: false });
			}

            mobileVerification.model.isShopBonus = bonusData.isShop;

            $.get(getDepositVerificationUrlForQuery() + $.param(parameterData), function (verificationData) {
                mobileVerification.model.templateData = {};
                $.extend(mobileVerification.model.templateData, {
                    mobile: verificationData.mobile,
                    callingCode: verificationData.callingCode,
                    isWithdraw: mobileVerification.model.type !== 'deposit'
                }, bonusData);
                mobileVerification.model.shouldVerify  = verificationData.verifyMobile;
                mobileVerification.model.initPromise.resolve();
            });
        });
        mobileVerification.$controller.on(bonusEvent.NO_SELECTED_BONUS, function () {
            mobileVerification.model.isShopBonus = false;
            $.get(getDepositVerificationUrlForQuery() + 'isBonusSelected=false', function (verificationData) {
                mobileVerification.model.templateData = {};
                $.extend(mobileVerification.model.templateData, {
                    mobile: verificationData.mobile,
                    callingCode: verificationData.callingCode,
                    isWithdraw: mobileVerification.model.type !== 'deposit'
                });
                mobileVerification.model.shouldVerify  = verificationData.verifyMobile;
                mobileVerification.model.initPromise.resolve();
            });
        });

        mobileVerification.$controller.on(bonusEvent.RESET_VERIFICATION, function () {
            if (mobileVerification.model.type === 'deposit') {
                mobileVerification.model.initPromise = comeon.promise.create();
            }
        });
    }

    function checkBonus(mobileVerification) {
        if (mobileVerification.model.type !== 'withdraw' && typeof(mobileVerification.model.templateData.resourceUrl) !== 'undefined') {
            bonusEvent.changeBonusHandler(mobileVerification.$controller, mobileVerification.$box, {
                description: mobileVerification.model.templateData.description,
                depositBonus: mobileVerification.model.templateData.depositBonus
            });

            if (mobileVerification.model.isShopBonus) {
                var $selectedBonusButtons = mobileVerification.$box.find('.selected-bonus span.s12-change').parent();
                $selectedBonusButtons.off('click').on('.click', function () {
                    $('#sliding-content-wrapper').find('.close').click();
                });
            }
        }
    }

    function setupWithdrawVerificationEventHandlers(mobileVerification) {
        mobileVerification.model.initPromise = comeon.promise.create();
        $.get(getWithdrawVerificationUrl(), function (verificationData) {
            mobileVerification.model.templateData = {};
            $.extend(mobileVerification.model.templateData, {
                mobile: verificationData.mobile,
                callingCode: verificationData.callingCode,
                isWithdraw: mobileVerification.model.type !== 'deposit'
            });
            mobileVerification.model.shouldVerify  = verificationData.verifyMobile;
            mobileVerification.model.initPromise.resolve();
        });
    }

    function setupMobileVerificationOnKeyup(mobileVerification) {
        var $mobileNumberRow = mobileVerification.$box.find('.form-group.row.mobile-number'),
            $inputElements = $mobileNumberRow.find('input');

        $inputElements.off('keyup').on('keyup', function () {
            var newCountryCode = $mobileNumberRow.find('.calling-code').val(),
                newNumber = $mobileNumberRow.find('.number').val(),
                oldMobile = mobileVerification.$box.find('.inner div.container div.col b').text(),
                newMobile = newCountryCode + newNumber;

            if (newMobile === oldMobile) {
                verification.resetChangeFrame($inputElements);
                return;
            }

            $.ajax({
                url: '/pp?flow=checkMobile',
                data: {
                    PARAM_PHONE_NUMBER: $mobileNumberRow.find('.number').val(),
                    PARAM_CALLING_CODE: $mobileNumberRow.find('.calling-code').val()
                }
            }).done(function (data) {
                if (data.RESULT === 'NOT_OK') {
                    showErrorTooltip($inputElements, data.ERROR);
                } else {
                    verification.resetChangeFrame($inputElements);
                }
            });
        });
    }

    var HTML = {method: 'html'},
        view = {
            render: function (mobileVerification) {
                var mustacheTemplateId = 'verification-mobile-template';
                $.Mustache.addFromDom(mustacheTemplateId);
                mobileVerification.$box.mustache(mustacheTemplateId, mobileVerification.model.templateData, HTML);
            }
        },
        model = {
            templateData : {},
            shouldVerify: undefined,
            initPromise: undefined,
            isShopBonus: false,
            isBonusFree: false,
            buttonHandlers: {
                updateHandler: updateMobile,
                resendHandler: resendMobile,
                verifyHandler: verifyMobile
            },
            init: function (mobileVerification) {
                mobileVerification.model.initPromise = comeon.promise.create();
                if (mobileVerification.model.type === 'deposit') {
                    setupDepositVerificationEventHandlers(mobileVerification);
                }

            },
            beforeRender: function (mobileVerification) {
                if (mobileVerification.model.type === 'withdraw') {
                    setupWithdrawVerificationEventHandlers(mobileVerification);
                }

                var shouldVerifyPromise = comeon.promise.create();
                comeon.promise.when([mobileVerification.model.initPromise])
                    .done(function () {
                        if (mobileVerification.model.shouldVerify) {
                            shouldVerifyPromise.resolve();
                        } else {
                            shouldVerifyPromise.reject();
                        }
                    }).always(function () {
                    mobileVerification.model.initPromise = comeon.promise.create();
                });
                return [shouldVerifyPromise.promise()];

            },
            afterRender: function (mobileVerification) {
                resendMobile(mobileVerification.$box, true);

                verification.setupVerificationButtons(
                    mobileVerification.$box,
                    mobileVerification.$controller,
                    mobileVerification.model.buttonHandlers);

                checkBonus(mobileVerification);

				if(mobileVerification.model.templateData.fromCarousel) {
					setDoneCallback(function(data, $box, $controller) {
						$controller.boxes[$controller.currentBoxIndex-2].model.chosenBonusId = mobileVerification.model.templateData.id;
						$controller.currentBoxIndex -= 3;
						$controller.nextBox();
					});
				} else {
					setDoneCallback(undefined);
				}

                setupMobileVerificationOnKeyup(mobileVerification);
            }
        };

    return {
        create: function ($box, $controller, type) {
            var mobileVerificationModelWithType = $.extend(
                {},
                model,
                type === 'withdraw' ? {type: 'withdraw'}: {type: 'deposit'}
            );
            return box.create($box, $controller, view, mobileVerificationModelWithType);
        },
		setDoneCallback: setDoneCallback
    };
});

